import { Component, computed, input } from '@angular/core';
import { AppPath } from '../../../app.routes';
import { AuthPath } from '../../../features/auth/auth.routes';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-user-avatar',
  imports: [RouterLink],
  template: `
    <div class="dropdown">
      <div tabindex="0" role="button" class="m-1 cursor-pointer">
        <div class="avatar avatar-placeholder">
          <div class="bg-neutral text-neutral-content w-12 rounded-full">
            <span>{{ initials() }}</span>
          </div>
        </div>
      </div>
      <ul
        tabindex="0"
        class="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm"
      >
        <li><a [routerLink]="logoutCommand">Logout</a></li>
      </ul>
    </div>
  `,
  styles: ``,
})
export class UserAvatarComponent {
  name = input<string>('Sample User');

  // 1) Iniciales a partir del nombre
  readonly initials = computed(() => {
    const value = this.name()?.trim() ?? '';
    if (!value) return '';

    const parts = value.split(/\s+/);
    const first = parts[0]?.[0] ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase();
  });
  protected readonly logoutCommand = ['/', AppPath.Auth, AuthPath.SignOut];
}
